var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgA5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.8 25.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-A5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46,7.65c-2,.27-4.05.59-6.1.88-.71.1-1.61.09-2.07.71a1.47,1.47,0,0,0,.19,2L4.36,15l1.41,1.38c.1.1.1.11.07.25L5.44,19l-.31,1.85L4.57,24.1A1.46,1.46,0,0,0,5,25.23l1,.4c.44.09,1.21-.42,1.54-.59L13.4,22l6.32,3.32,1.12.36a1.4,1.4,0,0,0,1.39-1.53l-1.29-7.62c.12-.22,5.51-5.22,5.67-5.62a1.6,1.6,0,0,0,0-1.4,1.5,1.5,0,0,0-1.28-.8l-7.11-1c-.28,0-.23-.11-.44-.53L14.49.48A1.49,1.49,0,0,0,12.36.4c-.21.22-1.46,2.75-2.42,4.71-.32.67-.61,1.26-.82,1.69-.11.25-.21.42-.26.54-.14.28,0,.25-.41.3Z",
    transform: "translate(0.01 0.01)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA5);
export default __webpack_public_path__ + "static/media/A5.49e1c3c67c95c965ccba2f0a145d955b.svg";
export { ForwardRef as ReactComponent };